<template>
  <div id="admin" :class="[{ 'collapsed' : collapsed }, { 'onmobile' : isOnMobile }]">
    <div class="admin">
      <!-- Header -->
      <!-- <div class="admin-header" :class="[collapsed ? 'extended' : 'normal']">
        <b-row>
          <b-col class="my-auto" cols="6">
            <router-link to="/admin">
              <img class="logo" src="../../assets/images/h3_logo.png" alt="Healthy Hip Hop Logo" />
            </router-link>
          </b-col>
          <b-col class="text-right my-auto" cols="6">
            <span class="logout-link" @click="logout">Logout</span>
          </b-col>
        </b-row>
      </div> -->

      <base-nav container-classes="container-fluid" class="navbar-top navbar-expand enhanced-navbar"
        :class="{ 'navbar-dark': type === 'default' }">
        <!-- Logo/Brand Section -->
        <!-- <div class="navbar-brand-section">
          <router-link to="/admin/dashboard" class="navbar-brand-link">
            <img src="../../assets/images/h3_logo.png" alt="H3 Admin" class="navbar-logo" />
            <span class="navbar-brand-text d-none d-lg-inline-block">H3 Admin</span>
          </router-link>
        </div> -->

        <!-- Current Page Indicator -->
        <!-- <div class="page-indicator d-none d-md-flex align-items-center">
          <i class="ni ni-chart-bar-32 page-icon"></i>
          <span class="page-title">{{ routeName }}</span>
        </div> -->

        <!-- Navbar links -->
        <b-navbar-nav class="align-items-center ml-md-auto">
          <!-- Mobile Search Toggle -->
          <li class="nav-item d-sm-none">
            <a class="nav-link search-toggle-btn" href="#" data-action="search-show" data-target="#navbar-search-main">
              <i class="ni ni-zoom-split-in"></i>
            </a>
          </li>
        </b-navbar-nav>
        <b-navbar-nav class="align-items-center ml-auto ml-md-0">
          <b-form class="navbar-search form-inline mr-sm-3 enhanced-search"
            :class="{ 'navbar-search-dark': type === 'default', 'navbar-search-light': type === 'light' }"
            id="navbar-search-main"
            @submit.prevent="performSearch">
            <b-form-group class="mb-0">
              <b-input-group class="input-group-alternative input-group-merge search-input-group">
                <!-- <div class="input-group-prepend">
                  <span class="input-group-text search-icon">
                    <i class="ni ni-zoom-split-in"></i>
                  </span>
                </div> -->
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search users, playlists, albums..."
                  type="text"
                  class="search-input"
                  @input="handleSearchInput"
                  @focus="showSearchDropdown = true"
                  @blur="hideSearchDropdown"
                  ref="searchInput">
                </b-form-input>

                <div class="input-group-append" v-if="searchQuery.length > 0">
                  <span class="input-group-text clear-btn" @click="clearSearch">
                    <i class="ni ni-fat-remove"></i>
                  </span>
                </div>
                <div class="input-group-append">
                  <span class="input-group-text search-btn" @click="performSearch">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </b-input-group>

              <!-- Search Results Dropdown -->
              <div v-if="showSearchDropdown && (searchResults.length > 0 || searchQuery.length > 2)"
                   class="search-dropdown">
                <div v-if="searchResults.length > 0" class="search-results">
                  <div v-for="result in searchResults" :key="result.id"
                       class="search-result-item"
                       @mousedown="navigateToResult(result)">
                    <div class="result-icon" :class="getResultIconClass(result.type)">
                      <i :class="getResultIcon(result.type)"></i>
                    </div>
                    <div class="result-content">
                      <div class="result-title">{{ result.title }}</div>
                      <div class="result-subtitle">{{ result.subtitle }}</div>
                      <div class="result-type">{{ result.type }}</div>
                    </div>
                  </div>
                </div>
                <div v-else-if="searchQuery.length > 2 && !isSearching" class="no-results">
                  <i class="ni ni-zoom-split-in"></i>
                  <span>No results found for "{{ searchQuery }}"</span>
                </div>
                <div v-else-if="isSearching" class="searching">
                  <i class="ni ni-watch-time"></i>
                  <span>Searching...</span>
                </div>
              </div>
            </b-form-group>
          </b-form>
          <base-dropdown menu-on-right class="nav-item enhanced-dropdown" tag="li" title-tag="a" title-classes="nav-link pr-0">
            <a href="#" class="nav-link pr-0 user-dropdown-toggle" @click.prevent slot="title-container">
              <b-media no-body class="align-items-center">
                <div class="avatar-container">
                  <span class="avatar avatar-sm rounded-circle user-avatar">
                    <i class="ni ni-single-02 text-white"></i>
                  </span>
                  <span class="online-indicator"></span>
                </div>
                <b-media-body class="ml-3 d-none d-lg-block">
                  <span class="mb-0 text-sm font-weight-bold user-name">H3 Admin</span>
                  <!-- <small class="text-muted user-role">Administrator</small> -->
                </b-media-body>
                <i class="ni ni-bold-down dropdown-arrow ml-2"></i>
              </b-media>
            </a>

            <template>
              <!-- <div class="dropdown-header-custom">
                <div class="user-info">
                  <div class="user-avatar-large">
                    <i class="ni ni-single-02 text-white"></i>
                  </div>
                  <div class="user-details">
                    <h6 class="mb-0">H3 Admin</h6>
                  </div>
                </div>
              </div> -->

              <!-- <b-dropdown-item class="dropdown-item-custom">
                <i class="ni ni-single-02"></i>
                <span>My Profile</span>
              </b-dropdown-item>

              <b-dropdown-item class="dropdown-item-custom">
                <i class="ni ni-settings-gear-65"></i>
                <span>Account Settings</span>
              </b-dropdown-item>

              <b-dropdown-item class="dropdown-item-custom">
                <i class="ni ni-notification-70"></i>
                <span>Notifications</span>
                <b-badge variant="danger" class="ml-auto notification-badge">3</b-badge>
              </b-dropdown-item>

              <b-dropdown-divider></b-dropdown-divider> -->

              <b-dropdown-item class="dropdown-item-custom logout-item" @click="logout">
                <i class="ni ni-user-run"></i>
                <span>Logout</span>
              </b-dropdown-item>
            </template>
          </base-dropdown>
        </b-navbar-nav>
      </base-nav>

      <!-- Container -->
      <div class="admin-container">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </div>

      <!-- Sidebar Menu -->
      <!-- <sidebar-menu :menu="menu" :collapsed="collapsed" :width="'280px'" :widthCollapsed="'50px'" :showOneChild="true"
        @toggle-collapse="onToggleCollapse">
      </sidebar-menu> -->
      <div class="sidebar-overlay" v-if="isOnMobile && !collapsed" @click="collapsed = true" />
      <side-bar>
        <hr class="my-3">
        <h6 class="navbar-heading p-0 text-muted">Adminitration</h6>
        <template slot="links">
          <sidebar-item v-for="(item, index) in menu" :key="index" :link="{
            name: item.title,
            path: item.href,
            icon: item.icon,
            children: item.child || []  // Asegúrate de incluir los subitems
          }">
            <template v-if="item.child && item.child.length">
              <sidebar-item v-for="(child, childIndex) in item.child" :key="childIndex" :link="{
                name: child.title,
                path: child.href,
              }"></sidebar-item>
            </template>
          </sidebar-item>


          <!-- <sidebar-item :link="{
            name: 'Icons',
            path: '/icons',
            icon: 'ni ni-planet text-blue'
          }">
          </sidebar-item>

          <sidebar-item :link="{
            name: 'Maps',
            path: '/maps',
            icon: 'ni ni-pin-3 text-orange'
          }">
          </sidebar-item>

          <sidebar-item :link="{
            name: 'User Profile',
            path: '/profile',
            icon: 'ni ni-single-02 text-yellow'
          }">
          </sidebar-item>

          <sidebar-item :link="{
            name: 'Tables',
            path: '/tables',
            icon: 'ni ni-bullet-list-67 text-red'
          }">
          </sidebar-item>

          <sidebar-item :link="{
            name: 'Login',
            path: '/login',
            icon: 'ni ni-key-25 text-info'
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'Register',
            path: '/register',
            icon: 'ni ni-circle-08 text-pink'
          }">
          </sidebar-item> -->
        </template>

        <template slot="links-after">
          <hr class="my-3">
          <h6 class="navbar-heading p-0 text-muted">Documentation</h6>

          <b-nav class="navbar-nav mb-md-3">
            <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/quick-start/argon-dashboard">
              <i class="ni ni-spaceship"></i>
              <b-nav-text class="p-0">Getting started</b-nav-text>
            </b-nav-item>
            <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/colors/argon-dashboard">
              <i class="ni ni-palette"></i>
              <b-nav-text class="p-0">Foundation</b-nav-text>
            </b-nav-item>
            <b-nav-item href="https://www.creative-tim.com/learning-lab/bootstrap-vue/avatar/argon-dashboard">
              <i class="ni ni-ui-04"></i>
              <b-nav-text class="p-0">Components</b-nav-text>
            </b-nav-item>
          </b-nav>
        </template>
      </side-bar>

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>

    <AppLoaderAdmin :isLoading="loading" />
  </div>
</template>

<script>

  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import ContentFooter from '../ContentFooter.vue';
  import axios from 'axios';


  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  export default {
    data() {
      return {
        loading    : false,
        collapsed  : false,
        isOnMobile : false,
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: '',
        showSearchDropdown: false,
        searchResults: [],
        isSearching: false,
        searchTimeout: null,
        menu       : [
          // {
          //   header           : true,
          //   title            : 'Administration',
          //   hiddenOnCollapse : true,
          // },
          {
            href  : '/admin/dashboard',
            title : 'Dashboard',
            icon  : 'ni ni-chart-bar-32',
          },
          // {
          //   href  : '/admin/featured',
          //   title : 'Featured',
          //   icon  : 'fas fa-star',
          // },
          // {
          //   href  : '/admin/categories',
          //   title : 'Categories',
          //   icon  : 'fas fa-object-group',
          //   child : [
          //     {
          //       href  : '/admin/categories/interact',
          //       title : 'Interact',
          //     },
          //   ],
          // },
          {
            title : 'Accounts',
            icon  : 'ni ni-single-02',
            child : [
              {
                href  : '/admin/users',
                title : 'Users',
              },
              {
                href  : '/admin/influencers',
                title : 'Influencers',
              },
              {
                href  : '/admin/enterprise',
                title : 'Enterprise',
              },
              {
                href  : '/admin/h3-characters',
                title : 'H3 Characters',
              },
            ],
          },
          {
            title : 'Albums',
            icon  : 'ni ni-note-03',
            child : [
              {
                href  : '/admin/music-albums/create',
                title : 'Create Music Album',
              },
              {
                href  : '/admin/music-albums',
                title : 'Music Albums',
              },
              // {
              //   href  : '/admin/challenges-albums/create',
              //   title : 'Create Challenges Album',
              // },
              // {
              //   href  : '/admin/challenges-albums',
              //   title : 'Challenges Albums',
              // },
               {
                href  : '/admin/playlist/1',
                title : 'Playlist',
              },
            ],
          },
          {
            title : 'Videos',
            icon  : 'ni ni-button-play',
            child : [
              {
                href  : '/admin/videos',
                title : 'Videos'
              },
              {
                href  : '/admin/videos/upload',
                title : 'Upload videos',
              },
            ],
          },
          {
            href  : '/admin/announcements',
            title : 'Announcements',
            icon  : 'ni ni-notification-70',
          },
          {
            href  : '/admin/live-broadcast',
            title : 'Live Broadcast',
            icon  : 'ni ni-world',
          },
          // {
          //   href  : '/admin/mobile-filter-assets',
          //   title : 'Mobile Filter Assets',
          //   icon  : 'fas fa-theater-masks',
          // },
          {
            href  : '/admin/moderate-content',
            title : 'Moderate Content',
            icon  : 'ni ni-check-bold',
          },
          // {
          //   href  : '/admin/playlist/1',
          //   title : 'Playlist',
          //   icon  : 'fas fa-stream',
          // },
          {
            href  : '/admin/web-settings',
            title : 'Web Settings',
            icon  : 'ni ni-settings',
            class : 'web-settings',
          },
        ],
      }
    },
    components : {
      'AppLoaderAdmin' : () => import('@/components/layout/AppLoaderAdmin'),
      'BaseDropdown': () => import('@/components/BaseDropdown'),
      'BaseNav': () => import('@/components/Navbar/BaseNav'),
      'side-bar': () => import('@/components/SidebarPlugin/SideBar'),
      ContentFooter
    },
    props: {
      type: {
        type: String,
        default: 'default', // default|light
        description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
      }
    },
    computed: {
      routeName() {
        const route = this.$route || {};
        const { name } = route;
        console.log('[9090]', name); // Desestructura el nombre de la ruta actual
        return this.capitalizeFirstLetter(name); // Llama a tu método de capitalización
      },
    },
    methods : {

      /**
       * On Sidebar Toggle
       * @param collapsed
       */
      onToggleCollapse(collapsed) {
        this.collapsed = collapsed;
      },


      /**
       * On Window Resize
       */
      onResize () {
        if (window.innerWidth <= 767) {
          this.isOnMobile = true;
          this.collapsed = true;
        } else {
          this.isOnMobile = false;
          this.collapsed = false;
        }
      },

      /**
       * Logout
       */
      logout() {
        this.loading = true;
        this.$http.post('/auth/logout', {
          accessToken  : (localStorage && localStorage.accessToken) || '',
          refreshToken : (localStorage && localStorage.refreshToken) || '',
        }).then(() => {
          if (window.localStorage) {
            window.localStorage.clear();
          }
          this.$router.replace('/admin/login');
        }).catch(() => {
          this.$notify({
            group : 'notif',
            type  : 'error',
            title : 'Failed',
            text  : 'Oops! Something went wrong!',
          });
        }).finally(() => {
          this.loading = false;
        });
      },


      capitalizeFirstLetter(string) {
        console.log('[ROUTER]', string);
        if (!string || typeof string !== 'string') {
          return 'Dashboard'; // Valor por defecto
        }
        return string.charAt(0).toUpperCase() + string.slice(1); // Capitaliza la primera letra
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      },
      collapseMenu() {
        this.collapsed = !this.collapsed;
      },

      /**
       * Handle search input with debounce
       */
      handleSearchInput() {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }

        if (this.searchQuery.length > 2) {
          this.searchTimeout = setTimeout(() => {
            this.performSearch();
          }, 300);
        } else {
          this.searchResults = [];
          this.showSearchDropdown = false;
        }
      },

      /**
       * Perform search across different content types
       */
      async performSearch() {
        if (!this.searchQuery || this.searchQuery.length < 3) return;

        this.isSearching = true;
        this.showSearchDropdown = true;

        try {
          const searchPromises = [
            this.searchUsers(),
            this.searchAlbums(),
            this.searchPlaylists(),
            this.searchVideos()
          ];

          const results = await Promise.all(searchPromises);
          this.searchResults = results.flat().slice(0, 8); // Limit to 8 results
        } catch (error) {
          console.error('Search error:', error);
          this.searchResults = [];
        } finally {
          this.isSearching = false;
        }
      },

      /**
       * Search users
       */
      async searchUsers() {
        try {
          const apiUrl = (process.env && process.env.VUE_APP_ROOT_API) || '';
          const response = await axios.get(`${apiUrl}api/users`, {
            params: { search: this.searchQuery, limit: 3 },
            headers: { 'Authorization': `Bearer ${(this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.accessToken) ? this.$store.state.auth.accessToken : ''}` }
          });

          return (response.data.data && response.data.data.map) ? response.data.data.map(user => ({
            id: user.id,
            title: user.nickname || user.name,
            subtitle: user.email,
            type: 'User',
            route: `/admin/users`,
            data: user
          })) : [];
        } catch (error) {
          return [];
        }
      },

      /**
       * Search music albums
       */
      async searchAlbums() {
        try {
          const apiUrl = (process.env && process.env.VUE_APP_ROOT_API) || '';
          const response = await axios.get(`${apiUrl}api/albums`, {
            params: { search: this.searchQuery, limit: 3 },
            headers: { 'Authorization': `Bearer ${(this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.accessToken) ? this.$store.state.auth.accessToken : ''}` }
          });

          return (response.data.data && response.data.data.map) ? response.data.data.map(album => ({
            id: album.id,
            title: album.title,
            subtitle: `by ${album.artist}`,
            type: 'Album',
            route: `/admin/music-albums`,
            data: album
          })) : [];
        } catch (error) {
          return [];
        }
      },

      /**
       * Search playlists
       */
      async searchPlaylists() {
        try {
          const apiUrl = (process.env && process.env.VUE_APP_ROOT_API) || '';
          const response = await axios.get(`${apiUrl}api/playlists`, {
            params: { search: this.searchQuery, limit: 3 },
            headers: { 'Authorization': `Bearer ${(this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.accessToken) ? this.$store.state.auth.accessToken : ''}` }
          });

          return (response.data.data && response.data.data.map) ? response.data.data.map(playlist => ({
            id: playlist.id,
            title: playlist.title,
            subtitle: `${playlist.song_count || 0} songs`,
            type: 'Playlist',
            route: `/admin/playlist/1`,
            data: playlist
          })) : [];
        } catch (error) {
          return [];
        }
      },

      /**
       * Search videos
       */
      async searchVideos() {
        try {
          const apiUrl = (process.env && process.env.VUE_APP_ROOT_API) || '';
          const response = await axios.get(`${apiUrl}api/videos`, {
            params: { search: this.searchQuery, limit: 3 },
            headers: { 'Authorization': `Bearer ${(this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.accessToken) ? this.$store.state.auth.accessToken : ''}` }
          });

          return (response.data.data && response.data.data.map) ? response.data.data.map(video => ({
            id: video.id,
            title: video.title,
            subtitle: (video.description && video.description.substring) ? video.description.substring(0, 50) + '...' : 'Video content',
            type: 'Video',
            route: `/admin/videos`,
            data: video
          })) : [];
        } catch (error) {
          return [];
        }
      },

      /**
       * Get icon for result type
       */
      getResultIcon(type) {
        const icons = {
          'User': 'ni ni-single-02',
          'Album': 'ni ni-music-note',
          'Playlist': 'ni ni-collection',
          'Video': 'ni ni-button-play'
        };
        return icons[type] || 'ni ni-world';
      },

      /**
       * Get icon class for result type
       */
      getResultIconClass(type) {
        const classes = {
          'User': 'user-icon',
          'Album': 'album-icon',
          'Playlist': 'playlist-icon',
          'Video': 'video-icon'
        };
        return classes[type] || 'default-icon';
      },

      /**
       * Navigate to search result
       */
      navigateToResult(result) {
        this.showSearchDropdown = false;
        this.searchQuery = '';
        this.searchResults = [];

        // Navigate to the appropriate route
        this.$router.push(result.route);

        // You can add additional logic here to highlight or focus the specific item
        // For example, store the selected item in localStorage or Vuex
        if (localStorage) {
          localStorage.setItem('searchResult', JSON.stringify(result));
        }
      },

      /**
       * Hide search dropdown
       */
      hideSearchDropdown() {
        setTimeout(() => {
          this.showSearchDropdown = false;
        }, 200); // Delay to allow click events
      },

      /**
       * Clear search input
       */
      clearSearch() {
        this.searchQuery = '';
        this.searchResults = [];
        this.showSearchDropdown = false;
        this.$refs.searchInput.focus();
      }
    },
    mounted() {
      this.initScrollbar();
      this.onResize();
      window.addEventListener('resize', this.onResize);

      this.$store.dispatch('playlist/getRecentSongs');
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/components/admin/main2';

  .navbar {
    z-index: 999;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    backdrop-filter: blur(10px);
    background: rgba(255, 255, 255, 1) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  /* Enhanced Navbar Styles */
  .enhanced-navbar {
    background: rgba(255, 255, 255, 1) !important;
    padding: 0.5rem 1rem;
    min-height: 70px;
  }

  /* Brand Section */
  .navbar-brand-section {
    display: flex;
    align-items: center;
  }

  .navbar-brand-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .navbar-brand-link:hover {
    transform: scale(1.02);
  }

  .navbar-logo {
    height: 40px;
    width: auto;
    margin-right: 12px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }

  .navbar-brand-text {
    font-size: 1.25rem;
    font-weight: 700;
    color: #5e72e4 !important;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    margin: 0;
  }

  /* Page Indicator */
  .page-indicator {
    margin-left: 2rem;
    padding: 0.5rem 1rem;
    background: rgba(94, 114, 228, 0.1);
    border-radius: 20px;
    border: 1px solid rgba(94, 114, 228, 0.2);
  }

  .page-icon {
    color: #5e72e4;
    margin-right: 8px;
    font-size: 16px;
  }

  .page-title {
    font-weight: 600;
    color: #5e72e4;
    font-size: 0.9rem;
  }

  /* Enhanced Search Toggle Button */
  .search-toggle-btn {
    padding: 0.5rem;
    border-radius: 8px;
    transition: all 0.3s ease;
  }

  .search-toggle-btn:hover {
    background: rgba(94, 114, 228, 0.1);
    color: #5e72e4;
  }

  .admin {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    min-height: 100vh;
  }

  .admin-container {
    // padding: 30px 20px;
    transition: all 0.3s ease;
  }

  /* Enhanced sidebar styling */
  .sidebar-overlay {
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
  }

  /* Smooth transitions for mobile menu */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }



  /* Loading animation for admin loader */
  .admin-loader {
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  /* Enhanced Search Styles */
  .enhanced-search {
    position: relative;
  }

  .search-input-group {
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    border-radius: 25px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    min-width: 300px;
  }

  .search-input-group:focus-within {
    box-shadow: 0 6px 20px rgba(94, 114, 228, 0.2);
    border-color: rgba(94, 114, 228, 0.3);
    transform: translateY(-1px);
  }

  .search-icon {
    background: linear-gradient(135deg, #5e72e4 0%, #4c63d2 100%);
    color: white;
    border: none;
    padding: 0.5rem 1rem;
  }

  .search-input {
    color: #32325d;
    border: none;
    background: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    padding: 0.5rem 1rem;
    min-width: 200px;
  }

  .search-input:focus {
    background: rgba(255, 255, 255, 1);
    box-shadow: none;
  }

  .search-input::placeholder {
    color: #8898aa;
    font-style: italic;
  }

  .clear-btn {
    cursor: pointer;
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
    border: none;
    padding: 0.5rem 0.75rem;
    transition: all 0.3s ease;
  }

  .clear-btn:hover {
    background: #dc3545 !important;
    color: white !important;
    transform: scale(1.1);
  }

  .search-btn {
    cursor: pointer;
    background: linear-gradient(135deg, #5e72e4 0%, #4c63d2 100%);
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    transition: all 0.3s ease;
  }

  .search-btn:hover {
    background: linear-gradient(135deg, #4c63d2 0%, #3b52c4 100%) !important;
    transform: scale(1.05);
  }

  .search-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .search-results {
    padding: 8px 0;
  }

  .search-result-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  .search-result-item:hover {
    background-color: rgba(94, 114, 228, 0.05);
  }

  .search-result-item:last-child {
    border-bottom: none;
  }

  .result-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    font-size: 16px;
    color: white;
  }

  .user-icon { background: linear-gradient(135deg, #5e72e4, #4c63d2); }
  .album-icon { background: linear-gradient(135deg, #2dce89, #1aa260); }
  .playlist-icon { background: linear-gradient(135deg, #fb6340, #f56036); }
  .video-icon { background: linear-gradient(135deg, #11cdef, #0da8c7); }
  .default-icon { background: linear-gradient(135deg, #8965e0, #6f42c1); }

  .result-content {
    flex: 1;
  }

  .result-title {
    font-weight: 600;
    color: #32325d;
    margin-bottom: 2px;
    font-size: 14px;
  }

  .result-subtitle {
    color: #8898aa;
    font-size: 12px;
    margin-bottom: 2px;
  }

  .result-type {
    font-size: 10px;
    color: #5e72e4;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .no-results, .searching {
    padding: 20px;
    text-align: center;
    color: #8898aa;
  }

  .no-results i, .searching i {
    font-size: 24px;
    margin-bottom: 8px;
    display: block;
  }

  /* Custom scrollbar for search dropdown */
  .search-dropdown::-webkit-scrollbar {
    width: 6px;
  }

  .search-dropdown::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 3px;
  }

  .search-dropdown::-webkit-scrollbar-thumb {
    background: rgba(94, 114, 228, 0.3);
    border-radius: 3px;
  }

  .search-dropdown::-webkit-scrollbar-thumb:hover {
    background: rgba(94, 114, 228, 0.5);
  }

  /* Enhanced User Dropdown */
  .enhanced-dropdown .dropdown-menu {
    border: none;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    margin-top: 15px;
    padding: 0;
    min-width: 280px;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
  }

  .user-dropdown-toggle {
    padding: 0.5rem 1rem;
    border-radius: 12px;
    transition: all 0.3s ease;
  }

  .user-dropdown-toggle:hover {
    background: rgba(94, 114, 228, 0.05);
  }

  .avatar-container {
    position: relative;
  }

  .user-avatar {
    border: 3px solid rgba(94, 114, 228, 0.2);
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #5e72e4 0%, #4c63d2 100%);
  }

  .user-dropdown-toggle:hover .user-avatar {
    border-color: rgba(94, 114, 228, 0.5);
    transform: scale(1.05);
  }

  .online-indicator {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 10px;
    height: 10px;
    background: #2dce89;
    border: 2px solid white;
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  }

  .user-name {
    color: #32325d;
    font-size: 0.9rem;
  }

  .user-role {
    font-size: 0.75rem;
    color: #8898aa;
    margin-top: -2px;
  }

  .dropdown-arrow {
    color: #8898aa;
    font-size: 12px;
    transition: all 0.3s ease;
  }

  .user-dropdown-toggle:hover .dropdown-arrow {
    color: #5e72e4;
    transform: rotate(180deg);
  }

  .dropdown-header-custom {
    padding: 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 12px 12px 0 0;
  }

  .user-info {
    display: flex;
    align-items: center;
  }

  .user-avatar-large {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    background: linear-gradient(135deg, #5e72e4 0%, #4c63d2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
    margin-right: 15px;
    box-shadow: 0 4px 12px rgba(94, 114, 228, 0.3);
  }

  .user-details h6 {
    margin: 0;
    font-weight: 600;
    color: #32325d;
  }

  .dropdown-item-custom {
    padding: 12px 20px;
    transition: all 0.3s ease;
    border-radius: 6px;
    margin: 2px 8px;
    font-weight: 500;
  }

  .dropdown-item-custom:hover {
    background: rgba(94, 114, 228, 0.08);
    color: #5e72e4;
    transform: translateX(5px);
  }

  .dropdown-item-custom i {
    width: 20px;
    margin-right: 12px;
    text-align: center;
    opacity: 0.7;
  }

  .dropdown-item-custom:hover i {
    opacity: 1;
  }

  .notification-badge {
    font-size: 0.7rem;
    padding: 0.2rem 0.5rem;
    border-radius: 10px;
  }

  .logout-item {
    color: #dc3545 !important;
  }

  .logout-item:hover {
    background: rgba(220, 53, 69, 0.08) !important;
    color: #dc3545 !important;
  }

  .logout-item i {
    color: #dc3545;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .enhanced-navbar {
      padding: 0.5rem;
      min-height: 60px;
    }

    .navbar-brand-section {
      flex: 1;
    }

    .navbar-logo {
      height: 32px;
      margin-right: 8px;
    }

    .navbar-brand-text {
      font-size: 1.1rem;
    }

    .page-indicator {
      display: none !important;
    }

    .enhanced-search .search-input-group {
      min-width: 250px;
    }

    .search-input {
      min-width: 150px;
    }

    .user-name {
      display: none;
    }

    .user-role {
      display: none;
    }

    .dropdown-header-custom {
      padding: 15px;
    }

    .user-avatar-large {
      width: 40px;
      height: 40px;
      font-size: 16px;
      margin-right: 12px;
    }
  }

  @media (max-width: 576px) {
    .enhanced-search .search-input-group {
      min-width: 200px;
    }

    .search-input {
      min-width: 120px;
      font-size: 0.85rem;
    }

    .navbar-brand-text {
      display: none;
    }

    .enhanced-dropdown .dropdown-menu {
      min-width: 250px;
    }
  }
</style>
